/*
    De inhoudsopgave van een blogartikel markeert de sectie die in beeld is.
    Progressive enhancement: zonder JS werkt de inhoudsopgave gewoon als lijst
    met ankerlinks.

    Het inpakken van tabellen zat hier ook, maar is verhuisd naar
    modules/wrap-tables.js — dat gold alleen voor blogartikelen terwijl
    Bard-tabellen net zo goed op gewone pagina's staan.
*/

export default function articleEnhancements () {
    const article = document.querySelector('.article');
    if ( !article ) return;

    markActiveSection(article);
}

function markActiveSection (article) {
    const links = [...article.querySelectorAll('.article-toc__link')];
    if ( !links.length ) return;

    const headings = links
        .map(link => document.getElementById(decodeURIComponent(link.hash.slice(1))))
        .filter(Boolean);

    if ( headings.length !== links.length ) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if ( !entry.isIntersecting ) return;

            const index = headings.indexOf(entry.target);

            links.forEach((link, i) => {
                link.setAttribute('aria-current', i === index ? 'true' : 'false');
            });
        });
    }, { rootMargin: '-10% 0px -75% 0px' });

    headings.forEach(heading => observer.observe(heading));
}
